import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle ">This tool can help</div>
                                            <p>It is not always easy to challenge others, especially when
                                                you do not know what the reaction will be or you are worried
                                                about the predicted reaction. This tool is about <span
                                                    className="green brownbold">How to challenge others effectively</span> and
                                                will help you to develop an understanding of how to
                                                challenge
                                                well, and discovering what is stopping you from doing this.
                                                You can begin to develop knowledge and experience of
                                                different techniques that you can use to challenge others,
                                                including body language.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>HOW TO CHALLENGE OTHERS EFFECTIVELY
                                            </div>
                                            <p>Any functioning relationship, whether at work or elsewhere,
                                                benefits when the parties are able to challenge each other
                                                in ways that increase understanding, or allow mutually
                                                acceptable decision making and resolution of
                                                disagreements. </p>
                                            <p>Great theory. The truth is that many of us avoid challenging
                                                anyone or anything, because we're worried either about
                                                making fools of ourselves, or about the reaction we might
                                                get. Even so, most of us would agree that we each have a
                                                right to make known our views and feelings about things.
                                                It's a tricky one - not wanting to 'rock the boat', exactly,
                                                but not minding if the other person fell overboard,
                                                either... </p>

                                            <p>We'll show you how to challenge constructively in a variety
                                                of circumstances, so, first, here's a model of different
                                                attitudes, or kinds of challenge (we call these 'stances')
                                                Our 'stance' depends on what we think and how we feel. That
                                                is, our mindset and level of aggression - the
                                                appropriateness of which depends on the situation. </p>
                                            <div className="mobile-scroll">
                                                <div className="challeng-bg">
                                                    <div className="effectively_challengebg">
                                                        <div className="effectivelychallengeletbox">
                                                            <div className="effectivelftpad1">
                                                                <textarea className="effectivematrixtextarea"
                                                                          name="HighClosed"
                                                                          value={this.props.pageData?.HighClosed}
                                                                          onChange={this.props.handleChangeTextarea}/>
                                                            </div>
                                                            <div className="effectivelftpad2">
                                                                <textarea className="effectivematrixtextarea"
                                                                          name="LowClosed"
                                                                          value={this.props.pageData?.LowClosed}
                                                                          onChange={this.props.handleChangeTextarea}/>
                                                            </div>
                                                        </div>


                                                        <div className="effectivelychallengergtbox">
                                                            <div className="effectivertpad1">
                                                                <textarea className="effectivematrixtextarea"
                                                                          name="HighOpen"
                                                                          value={this.props.pageData?.HighOpen}
                                                                          onChange={this.props.handleChangeTextarea}/>
                                                            </div>
                                                            <div className="effectivertpad2">
                                                                <textarea className="effectivematrixtextarea"
                                                                          name="LowOpen"
                                                                          value={this.props.pageData?.LowOpen}
                                                                          onChange={this.props.handleChangeTextarea}/>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page3')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}